import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-restart",
  "use": "icon-icon-restart-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-icon-restart\">\r\n  <defs>\r\n    <style>\r\n      #icon-icon-restart .cls-1 {\r\n        fill: #48a0ff;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-icon-restart_undo\" class=\"cls-1\" d=\"M117.991,124A6.089,6.089,0,0,0,112,130.184a6.244,6.244,0,0,0,2.307,4.874l-.562.742a.124.124,0,0,0,.094.2l2.505-.012a.122.122,0,0,0,.116-.153l-.593-2.51a.119.119,0,0,0-.211-.046l-.61.806a4.964,4.964,0,0,1-1.469-1.975,5.111,5.111,0,0,1,0-3.851,4.939,4.939,0,0,1,1.029-1.573,4.774,4.774,0,0,1,1.526-1.061,4.69,4.69,0,0,1,3.737,0,4.775,4.775,0,0,1,1.525,1.061,4.939,4.939,0,0,1,1.029,1.573,5.111,5.111,0,0,1,0,3.851,4.939,4.939,0,0,1-1.029,1.573c-.112.116-.229.224-.351.328a.125.125,0,0,0-.018.172l.591.781a.119.119,0,0,0,.171.02,6.247,6.247,0,0,0,2.214-4.8A6.093,6.093,0,0,0,117.991,124Z\" transform=\"translate(-112 -124)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-restart.svg
// module id = BePF
// module chunks = 3